// extracted by mini-css-extract-plugin
export var author = "style-module--author--7a4e4";
export var author__container = "style-module--author__container--ba1d1";
export var author__description = "style-module--author__description--4b377";
export var author__el = "style-module--author__el--7ef6b";
export var author__name = "style-module--author__name--1300c";
export var author__photo = "style-module--author__photo--46561";
export var author__title = "style-module--author__title--81477";